import { ThemeModeType } from '../../utils';
import { ThemeModeComponent } from '../../models/layout';

export const themeModeLSKey = 'kt_theme_mode_value';
export const themeMenuModeLSKey = 'kt_theme_mode_menu';

export const systemMode = ThemeModeComponent.getSystemMode() as 'light' | 'dark';
export const themeModeSwitchHelper = (_mode: ThemeModeType) => {
   // change background image url
   const mode = _mode !== 'system' ? _mode : systemMode;
   const imageUrl = './media/patterns/header-bg' + (mode === 'light' ? '.jpg' : '-dark.png');
   if (document) {
      document.body.style.backgroundImage = `url('${imageUrl}')`;
   }
};

export const getThemeModeFromLocalStorage = (lsKey: string): ThemeModeType => {
   if (!localStorage) {
      return 'light';
   }

   const data = localStorage?.getItem(lsKey);
   if (!data) {
      return 'light';
   }

   if (data === 'light') {
      return 'light';
   }

   if (data === 'dark') {
      return 'dark';
   }

   return 'system';
};
